import { faSave } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Button from 'components/base/Button';
import PitchDeckLayout from 'layouts/PitchDeckLayout';
import { Card, Col } from 'react-bootstrap';
import Dropzone from 'components/base/Dropzone';

const AddMedia = () => {
  return (
    <PitchDeckLayout page="media">
      <Col>
        <Card className="email-content d-flex flex-column h-100">
          <Card.Body className="d-flex flex-column h-100">
            <form className="flex-grow-1 d-flex flex-column">
              <div className="mb-3 flex-grow-1">
                <Dropzone
                  className="mb-3"
                  accept={{
                    'image/*': ['.png', '.gif', '.jpeg', '.jpg']
                  }}
                />
              </div>
              <div className="d-flex justify-content-between align-items-center">
                <div className="d-flex gap-3"></div>
                <div className="d-flex">
                  <Button
                    variant="link"
                    className="text-900 fs-10 text-decoration-none"
                  >
                    Close
                  </Button>
                  <Button
                    variant="primary"
                    className="fs-10"
                    type="submit"
                    endIcon={<FontAwesomeIcon icon={faSave} />}
                  >
                    Save
                  </Button>
                </div>
              </div>
            </form>
          </Card.Body>
        </Card>
      </Col>
    </PitchDeckLayout>
  );
};

export default AddMedia;
